import React, { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import InstantSearchProvider from '../InstantSearchProvider';
import InventoryProvider from '../InventoryProvider';
import Items from './Items';
import SkeletonItems from './SkeletonItems';
import { PRODUCT_SEARCH_INDEX } from '~constants/search';
import { getSimilarProducts } from '~graphql/queries';

import { authUserSelector } from '~redux/auth/selectors/authUser';
import { useGraphql } from '~view/hooks/graphql';

const SimilarProducts: React.FC<{ productId: string; brandId: string }> = ({
  productId,
  brandId,
}) => {
  const user = useSelector(authUserSelector);
  const [similarProducts, fetchSimilarProducts, isLoading] = useGraphql<
    string[]
  >(getSimilarProducts, (data) => {
    return data.getSimilarProducts;
  });

  useEffect(() => {
    if (!user) return;
    fetchSimilarProducts({
      userId: user.attributes.sub,
      productId,
      count: 30,
    });
  }, [user]);

  const filter = useMemo(
    () =>
      `category_page_id:products AND (${similarProducts
        ?.map((productId) => `id:'${productId}'`)
        .join(' OR ')})`,
    [similarProducts]
  );

  if (isLoading) {
    return <SkeletonItems />;
  }

  if (!similarProducts) {
    return null;
  }

  return (
    <InventoryProvider productIds={similarProducts}>
      <InstantSearchProvider indexName={PRODUCT_SEARCH_INDEX} filters={filter}>
        <Items productIds={similarProducts} />
      </InstantSearchProvider>
    </InventoryProvider>
  );
};

export default SimilarProducts;
